import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import IndexPage from "./pages/index";

ReactDOM.render(<IndexPage />, document.getElementById("root"));
